import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconElevator({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M2 11a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4A.5.5 0 0 1 2 11zm11.5 2a.5.5 0 0 1 0 1h-8a.5.5 0 0 1 0-1h8zM2 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm13.5.5a.5.5 0 0 1 0 1h-10a.5.5 0 0 1 0-1h10zM2 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4A.5.5 0 0 1 2 0zm11.5 2a.5.5 0 0 1 0 1h-8a.5.5 0 0 1 0-1h8z"/>
        </svg>
    );
}

export default IconElevator;
